<template>
  <div class="q-pa-md">
    <div class="row">
      <h4>
        Source Filters ({{ stream.sources.length + sourceGroupFilters.length }})
      </h4>
      <span
        v-if="expandable"
        class="q-ml-auto cursor-pointer self-center"
      >
        <span
          v-if="!expandedTabs"
          @click="expandedTabs = true"
        >
          <div class="soft row">
            Show
            <QIcon
              class="contact-icon self-center"
              name="arrow_drop_down"
              size="20px"
            />
          </div>
        </span>
        <span
          v-else
          @click="expandedTabs = false"
        >
          <div class="soft">Hide</div>
          <QIcon
            class="contact-icon"
            name="arrow_drop_up"
            size="20px"
          />
        </span>
      </span>
    </div>
    <span v-if="!expandable || expandedTabs">
      <QTabs
        v-model="selectedTab"
        active-color="primary"
        align="justify"
        class="text-grey"
        indicator-color="primary"
        narrow-indicator
      >
        <QTab name="single"> SINGLE ({{ stream.sources.length }}) </QTab>
        <QTab name="group"> GROUP ({{ sourceGroupFilters.length }}) </QTab>
      </QTabs>
      <QTabPanels v-model="selectedTab">
        <QTabPanel name="single">
          <div class="text-h6">
            <FilterSourceTab
              v-model="stream.sources"
              condition-field="classField"
              condition-filter="target_type"
              :no-exclusions="noExclusions"
              source-type="Single"
              :sources="sources"
              :text-types="['id', 'name', 'location']"
            />
          </div>
        </QTabPanel>

        <QTabPanel name="group">
          <div class="text-h6">
            <FilterSourceTab
              v-model="sourceGroupFilters"
              condition-field="field"
              condition-filter="scope"
              :no-exclusions="noExclusions"
              source-type="Group"
              :sources="sources"
              :text-types="['name']"
            />
          </div>
        </QTabPanel>
      </QTabPanels>
    </span>
  </div>
</template>

<script>
import FilterSourceTab from "src/components/sources/FilterSourceTab.vue";

export default {
  name: "SpecificSources",
  components: {
    FilterSourceTab,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    sources: {
      type: Array,
      default: () => [],
    },
    noExclusions: {
      type: Boolean,
    },
    expandable: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectedTab: "single",
      expandedTabs: false,
    };
  },
  computed: {
    stream: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    sourceGroupFilters: {
      get() {
        return this.stream.filters.filter(
          (filter) => filter.target_type === "SourceGroup"
        );
      },
      set(value) {
        const otherFilters = this.stream.filters.filter(
          (filter) => filter.target_type !== "SourceGroup"
        );

        this.stream.filters = [...otherFilters, ...value];
        this.$emit("update:modelValue", this.stream);
      },
    },
  },
  mounted() {
    if (!this.stream.sources) this.stream.sources = [];
  },
};
</script>
